/// <reference path='../../_references.ts' />

module onvio.setup.customFieldsSetup {
    'use strict';

    export class CustomFieldsSetupController {

        static $inject = [
            'bluemoon.components.NavigationUtils',
            '$injector',
        ];
        constructor(
            private navigation: bluemoon.components.INavigationUtilsService,
            private $injector: ng.auto.IInjectorService,
        ) {
            this.onNavigateAway = this.onNavigateAway.bind(this);
            this.navigation.preventNavigation(this.onNavigateAway, true);
        }

        onNavigateAway() {
            // this injector is needed because bmcCustomFieldsSaveService is not always
            // available on init of the controller
            return this.$injector.invoke(['bmcCustomFieldsSaveService', function(cfSaveService) {
                return cfSaveService.savedSuccessfully().then(function(res: boolean) {
                    return res;
                });
            }]);
        }
    }

    angular.module('onvio.setup.customFieldsSetup', [])
        .controller('onvio.setup.CustomFieldsSetupController', CustomFieldsSetupController)
        .config(['$stateProvider', ($stateProvider: ng.ui.IStateProvider) => {
        $stateProvider.state('setup-custom-fields', {
            url: '/setup/custom-fields',
            templateUrl: 'setup/src/custom-fields/custom-fields-setup.html',
            controller: 'onvio.setup.CustomFieldsSetupController as vm',
            resolve: {
                permission: ['$state', 'bmPermission', function($state: ng.ui.IStateService, bmPermission: any) {
                    bmPermission.has('OnvioSetup.CustomFields').then(function() {
                        angular.noop();
                    }).catch(function() {
                        $state.go('notfound', {}, { location: 'replace' });
                    });
                }],
            },
        });
    }]);
}
